import axios from 'axios'
import { useToast } from 'vue-toast-notification'
import { useAuthStore } from '@/stores/authStore'

declare module 'axios' {
  interface AxiosRequestConfig {
    suppressGlobalErrorToast?: boolean
  }
}

const $toast = useToast({ position: 'bottom-right' })
const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE
})

const refreshApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE,
  withCredentials: true
})

let accessToken = localStorage.getItem('access') || ''

http.interceptors.request.use(
  async (config) => {
    accessToken = localStorage.getItem('access') || ''
    config.headers['Authorization'] = 'Bearer ' + accessToken
    config.withCredentials = true
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (response) => {
    if (response.data.status === 'error' && !response.config.suppressGlobalErrorToast) {
      $toast.error(response.data.msg)
    }
    return response
  },
  async (error) => {
    console.log(error)
    const status = error.response?.status
    const isRefreshEndpoint = error.config?.url?.includes('/auth/refresh')
    const isLoginEndpoint = error.config?.url?.includes('/auth/login')
    const store = useAuthStore()
    // Обрабатываем 401 и сетевые ошибки (когда нет response)
    if (
      ((status === 401 || !error.response) && !isLoginEndpoint) && !isRefreshEndpoint
    ) {
      await store.refreshToken(true)
    }  else if (status === 403) {
      store.logOut()
    } else if (status === 500 && !error.config?.suppressGlobalErrorToast) {
      $toast.error('Ошибка сервера')
    } else if (error.response?.data?.msg && !error.config?.suppressGlobalErrorToast) {
      $toast.error(error.response.data.msg)
    }
    return Promise.reject(error)
  }
)

refreshApi.interceptors.response.use(
  (response) => {
    if (response.data.status === 'error') {
      $toast.error(response.data.msg)
    }
    return response
  },
  async (error) => {
    console.log(error)
    const status = error.response?.status
    const store = useAuthStore()
    // Обрабатываем 401 и сетевые ошибки (когда нет response)
    if (status === 403) {
      store.logOut()
    } else if (status === 500) {
      $toast.error('Ошибка сервера')
    } else if (error.response?.data?.msg) {
      $toast.error(error.response.data.msg)
    }
    return Promise.reject(error)
  }
)

export { http, refreshApi }
